import React from 'react';
import AltovaProductTile from './AltovaProductTile';
import './tiles.scss';

function AltovaProductTileHolder({ tileContents }) {
    return (
        <div className="tile-holder">
          {tileContents.map((product) => (
            <AltovaProductTile key={product.id} {...product} />
          ))}
        </div>
      );
}

export default AltovaProductTileHolder;
